import React, { useState } from 'react';
import './ApplicationForm.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCheck, FaWhatsapp } from 'react-icons/fa';

export default function ApplicationForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const job = location.state?.job || { id: '', title: '' };

  const [form, setForm] = useState({
    position: job.title || '',
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [cvFile, setCvFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (error) setError('');
  }

  function handleFile(e) {
    const file = e.target.files[0];
    if (file) setCvFile(file);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      let cv = null;
      if (cvFile) {
        cv = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve({ name: cvFile.name, type: cvFile.type, size: cvFile.size, dataUrl: reader.result });
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(cvFile);
        });
      }
      const payload = {
        name: form.name,
        email: form.email,
        phone: form.phone,
        message: form.message,
        position: form.position,
        jobId: job.id || '',
        jobTitle: job.title || form.position,
        cv,
      };
      const base = process.env.REACT_APP_PUBLICATION_SERVICE || 'http://localhost:4300';
      const res = await fetch(base + '/applications', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
      });
      const json = await res.json().catch(() => null);
      if (!res.ok || (json && json.success === false)) {
        throw new Error((json?.error?.message) || `Erreur ${res.status}`);
      }
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Erreur inconnue. Reessayez ou ecrivez-nous directement.');
    } finally {
      setSubmitting(false);
    }
  }

  if (submitted) {
    const waText = encodeURIComponent(`Bonjour, je viens d'envoyer ma candidature pour le poste : ${form.position}. Je voulais confirmer la bonne reception.`);
    return (
      <div className="appform-success">
        <div className="appform-success__icon">
          <FaCheck size={28} />
        </div>
        <h2 className="appform-success__title">Candidature envoyee !</h2>
        <p className="appform-success__text">
          Merci <strong>{form.name}</strong>. Votre dossier a bien ete recu.
          Nous examinons chaque candidature et vous repondrons sous <strong>5 jours ouvrables</strong>.
        </p>
        <div className="appform-success__actions">
          <a
            href="mailto:contact@nxs-solutions.com"
            className="appform-success__wa"
          >
            Nous ecrire par email
          </a>
          <button
            type="button"
            className="appform-success__back"
            onClick={() => navigate('/careers')}
          >
            Retour aux offres
          </button>
        </div>
      </div>
    );
  }

  const allValid = (
    (form.position || '').trim() &&
    (form.name || '').trim() &&
    (form.email || '').trim() &&
    (form.phone || '').trim() &&
    (form.message || '').trim() &&
    !!cvFile
  );

  return (
    <form className="contact-form application-form" onSubmit={handleSubmit}>
      {error && (
        <div className="appform-error">{error}</div>
      )}

      <label>
        Poste
        <input
          name="position"
          value={form.position}
          onChange={handleChange}
          disabled
          required
          style={{ background: '#f1f5f9', color: '#64748b' }}
        />
      </label>

      <div className="row">
        <label>
          Nom complet
          <input name="name" value={form.name} onChange={handleChange} placeholder="Votre nom complet" required />
        </label>
      </div>

      <div className="row">
        <label>
          Email
          <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="adresse@exemple.com" required />
        </label>
        <label>
          Telephone
          <input name="phone" value={form.phone} onChange={handleChange} placeholder="+225 00 00 00 00" required />
        </label>
      </div>

      <label>
        Lettre de motivation
        <textarea
          name="message"
          value={form.message}
          onChange={handleChange}
          rows={6}
          placeholder="Presentez-vous brievement et expliquez pourquoi vous postulez..."
          required
        />
      </label>

      <label className="file">
        Joindre CV (PDF / DOCX) *
        <input type="file" accept=".pdf,.doc,.docx" onChange={handleFile} required />
        {cvFile && <div className="file-name">{cvFile.name}</div>}
      </label>

      <div className="actions">
        <button type="button" className="btn-secondary" onClick={() => navigate(-1)}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Retour
        </button>
        <button className="btn-primary" type="submit" disabled={submitting || !allValid}>
          {submitting ? 'Envoi...' : 'Envoyer ma candidature'}
        </button>
      </div>
    </form>
  );
}
